import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-warning-message',
  templateUrl: './warning-message.component.html',
  styleUrls: ['./warning-message.component.scss'],
  standalone: false
})
export class WarningMessageComponent implements OnInit {
  @Input() icon: string = 'alert-circle-outline';
  @Input() message: string = '';
  @Input() color: string = '#faad14'; // default warning color
  @Input() url?: string; // optional URL for redirection

  constructor(private router: Router) { }

  ngOnInit() {}

  onWarningClick() {
    if (this.url) {
      this.router.navigate([this.url]);
    }
  }

  get isClickable(): boolean {
    return !!this.url;
  }
}
